<template>
  <div class="fundMain">
    <van-nav-bar title="资金交存" left-arrow @click-left="onClickLeft" />

    <div v-if="dataList.length">
      <div class="item" v-for="(item, index) in dataList" :key="index" @click="getInfo(item)">
        <div class="content">
          <p class="title">{{ item.wyqymc }}</p>
          <img class="icon" src="../../assets/img/img_tab_red.png" alt="" />
          <div style="margin-top: 16px">
            <img class="location" src="../../assets/img/icon_location.png" alt="" />&nbsp;<span class="address">{{
              item.fwdz
            }}</span>
          </div>
        </div>
        <div class="footer">
          <div class="left">
            <span class="hoster"> 业主：</span><span>{{ item.yz }}</span>
          </div>
          <div class="right">
            <span>账面余额：</span>
            <span class="money">{{ "￥" + item.zmye }}</span>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <nodata></nodata>
    </div>

  </div>
</template>

<script>
import api from '@/api/query.js'
import nodata from './noData.vue'
export default {
  name: '',
  components: {
    nodata
  },
  data() {
    return {
      dataList: [
        // {
        //   title: "富丽花城1期",
        //   address: "江苏省南京市市辖区 2 幢 261 室",
        //   hostname: '李永平',
        //   status: "正常",
        //   total: 1900.9
        // },

      ]
    }
  },
  created() {

  },
  mounted() {
    this.getList()
  },

  methods: {
    onClickLeft() {
      window.history.go(-1)
    },
    getList() {
      let userinfo = JSON.parse(sessionStorage.getItem('userinfo'))
      let wyqydm = JSON.parse(sessionStorage.getItem('wyqydm')) || 'test'
      let params = {
        wyqydm: wyqydm,
        zjhm: userinfo.zjhm
      }
      api.getJcTzd(params).then(res => {
        if (res.data.code == 200) {
          this.dataList = res.data.data
        } else {
          this.$toast.fail({
            message: '操作失败',
          })
        }

      }).catch(err => {
        this.$toast.fail({
          message: err,
        })
      })
    },

    getInfo(item) {
      location.href = 'saveDetail' + '?id=' + item.tzdid
      // location.href = 'https://wxzjzf.qwxfgs.cn/' + '?tzdid' + item.tzdid
      // this.$router.push({ path: 'saveDetail', query: { id: item.tzdid } })
    }
  }
}
</script>

<style lang="less" scoped>
.fundMain {
  height: 100%;
  background: #f4f7f9;

  .item {
    height: 134px;
    padding: 16px;
    margin-bottom: 20px;

    .content {
      position: relative;
      width: 100%;
      min-height: 98px;
      padding: 20px 0 20px 16px;
      background: #ffffff;

      .title {
        width: 200px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        height: 22px;
        font-size: 16px;
        font-family: PingFang SC-Semibold, PingFang SC;
        font-weight: 600;
        color: #222120;
        line-height: 19px;
        margin: 0;
      }

      .icon {
        position: absolute;
        top: 20px;
        right: -2px;
        width: 56px;
        height: 26px;
      }

      .location {
        width: 20px;
        height: 20px;
        vertical-align: middle;
      }

      .address {
        // display: inline-block;
        width: 80%;
        min-height: 20px;
        font-size: 14px;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #4e4d4d;
        line-height: 16px;
        vertical-align: middle;
        margin: 0;
        // overflow: hidden;
        // text-overflow: ellipsis;
        // white-space: nowrap;
      }

      .footer {
        height: 30px;
        width: 100%;
        // border-top: 1px solid #4e4d4d;
      }
    }

    .footer {
      display: flex;
      align-items: center;
      width: 100%;
      height: 36px;
      background: #ffffff;
      border-radius: 0px 0px 0px 0px;
      border-top: 1px solid rgb(217, 217, 217);
      opacity: 1;

      .left {
        flex: 50%;
        height: 17px;
        font-size: 12px;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #222120;
        line-height: 14px;
        padding-left: 16px;
        line-height: 17px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;

        .hoster {
          font-weight: 700;
        }
      }

      .right {
        flex: 50%;
        height: 17px;
        font-size: 12px;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #222120;
        line-height: 14px;
        padding-left: 16px;
        line-height: 17px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;


        .money {
          font-weight: 700;

        }
      }
    }
  }
}
</style>
